// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"60aba32a","112":"168fefcc","461":"df09b8ce","488":"f28827a2","526":"381859dd","583":"a79096b2","694":"8640a630","718":"17aa7015","885":"f924eef8","931":"db0076d9","980":"f13e25ed"}[chunkId] + ".chunk.js";
};